import { FC } from 'react'
import { createPortal } from 'react-dom'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'

const DELETE_TASK_MODAL_Z_INDEX = 110

type DeleteTaskModalProps = {
  taskTitle: string
  open: boolean
  loading?: boolean
  onConfirm: () => void
  onDismiss: () => void
}

const DeleteTaskModal: FC<DeleteTaskModalProps> = ({
  taskTitle,
  open,
  loading = false,
  onConfirm,
  onDismiss,
}) => {
  if (!open) return null

  return createPortal(
    <Modal
      active={open}
      className={`${mclasses.confirmModalWrapper} ${mclasses.taskTrackerModalWrapper}` as any}
      style={{ zIndex: String(DELETE_TASK_MODAL_Z_INDEX) }}
      setActive={() => {
        if (loading) return
        onDismiss()
      }}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>Удалить задачу?</span>
          </div>
          <button
            type="button"
            className={mclasses.closeIcon}
            onClick={onDismiss}
            aria-label="Закрыть"
            disabled={loading}
          >
            <IcoRemove />
          </button>
        </div>
        <div className={mclasses.formWrapper}>
          <p className={mclasses.modalDescription}>
            Задача будет удалена без возможности восстановления.
          </p>
          <p className={mclasses.modalDescription} style={{ fontWeight: 600 }}>
            {taskTitle}
          </p>
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={onDismiss} disabled={loading}>
            Отменить
          </Button>
          <Button
            color="primary"
            onClick={onConfirm}
            isLoading={loading}
            disabled={loading}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>,
    document.body,
  )
}

export default DeleteTaskModal
